// [목적] /settings 페이지 전용 feature flag 상수 모듈 — SHOW_EMAIL_ROW 단일 SoT(Source of Truth) 제공
// [이유] 사용자 설정 "계정" 섹션의 이메일 행은 현재 BE 이메일 변경 엔드포인트 미제공으로
//         실제 변경 불가 상태임. 혼선 축소를 위해 잠정적으로 행·라우트를 동시에 숨기되,
//         전역 feature-flag 시스템 도입은 과설계(Spec §8 R-3)이므로
//         pages/auth/tokens.ts, pages/landing/tokens.ts 패턴과 같이 페이지 스코프 상수 모듈로 colocate.
//         이 파일을 단일 SoT 로 삼아 SettingsPage.tsx(행 비렌더)와 routes.tsx(라우트 리다이렉트)가
//         동일 값을 참조함으로써 플래그 1개만 토글하면 두 곳이 함께 원복된다(Spec AC-8).
// [사이드 이팩트] - SettingsPage.tsx: 이메일 Row 조건부 비렌더(false → DOM 제거, Tab/스크린리더 잔존 없음)
//                 - routes.tsx: path='settings/email' element 를 <Navigate to="/settings" replace /> 로 게이팅
//                 - EmailScreen(SettingsSubPages.tsx) 코드는 보존 — 라우트 삼항 true 분기에서 계속 참조
//                 - useMe()/GET /users/me/me.emailMasked 호출은 다른 행이 계속 소비하므로 데이터 부작용 없음
// [수정 시 고려사항] BE 이메일 변경 엔드포인트 등 재노출 트리거 충족 시 `true` 로 변경하면
//                   행·라우트가 함께 원복된다(시점 미정).
//                   향후 유사 임시 flag 가 늘어날 경우 전역 flag 시스템 도입을 별도 Spec 으로 검토.
//                   이 파일은 의존성 0 (MUI/JSX 등 외부 import 금지) — routes.tsx 가 import 시
//                   라우트 모듈 그래프에 무거운 UI 모듈이 끌려오지 않도록 유지할 것.

// ─── Feature Flags ────────────────────────────────────────────────────────────

/**
 * 사용자 설정 "계정" 섹션의 이메일 행 표시 여부.
 *
 * false(기본): 이메일 행을 DOM 에서 제거하고 /settings/email 직접 접근 시 /settings 로 리다이렉트.
 * true        : 이메일 행을 원래 위치(이름 행과 비밀번호 변경 행 사이)에 표시하고 /settings/email 라우트 정상 동작.
 *
 * 재노출 조건: BE 이메일 변경 엔드포인트 마련 후 이 값을 true 로 변경.
 */
export const SHOW_EMAIL_ROW = false;
